import { mediaQueryLarge, requestIdleCallback, startViewTransition } from "@theme/utilities";
import PaginatedList from "@theme/paginated-list";
//#region assets/results-list.ts
/**
* A custom element that renders a pagniated results list
*/
var ResultsList = class extends PaginatedList {
	connectedCallback() {
		super.connectedCallback();
		mediaQueryLarge.addEventListener("change", this.#handleMediaQueryChange);
		this.setAttribute("initialized", "");
	}
	disconnectedCallback() {
		mediaQueryLarge.removeEventListener("change", this.#handleMediaQueryChange);
	}
	/**
	* Updates the layout.
	*
	* @param {Event} event
	*/
	updateLayout({ target }) {
		if (!(target instanceof HTMLInputElement)) return;
		this.#animateLayoutChange(target.value);
	}
	/**
	* Sets the layout.
	*
	* @param {string} value
	*/
	#animateLayoutChange = async (value) => {
		const { grid } = this.refs;
		if (!grid) return;
		await startViewTransition(() => this.#setLayout(value), ["product-grid"]);
		requestIdleCallback(() => {
			const viewport = mediaQueryLarge.matches ? "desktop" : "mobile";
			sessionStorage.setItem(`product-grid-view-${viewport}`, value);
		});
	};
	/**
	* Animates the layout change.
	*
	* @param {string} value
	*/
	#setLayout(value) {
		const { grid } = this.refs;
		if (!grid) return;
		grid.setAttribute("product-grid-view", value);
	}
	/**
	* Handles the media query change event.
	*
	* @param {MediaQueryListEvent} event
	*/
	#handleMediaQueryChange = (event) => {
		const targetElement = event.matches ? this.querySelector("[data-grid-layout=\"desktop-default-option\"]") : this.querySelector("[data-grid-layout=\"mobile-option\"]");
		if (!(targetElement instanceof HTMLInputElement)) return;
		targetElement.checked = true;
		this.#setLayout("default");
	};
};
if (!customElements.get("results-list")) customElements.define("results-list", ResultsList);
//#endregion
export { ResultsList as default };
